import { Component, ErrorInfo, ReactNode } from 'react';
import { appInsights } from '../services/telemetry';
import { SeverityLevel } from '@microsoft/applicationinsights-web';

interface Props {
  children: ReactNode;
}

export class AppInsightsErrorBoundary extends Component<Props> {
  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    appInsights.trackException({
      exception: error,
      severityLevel: SeverityLevel.Error,
      properties: {
        componentStack: errorInfo.componentStack ?? '',
      },
    });
  }

  render() {
    return this.props.children;
  }
}
